import React from 'react';
import { CTASection } from '../components/CTASection';
export const ContactPage = () => {
  return <div className="pt-8" data-id="element-229">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-230">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-231">
          Get in Touch
        </h1>
        <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto" data-id="element-232">
          Ready to transform your sales hiring? Schedule a demo with our team.
        </p>
      </div>
      <CTASection data-id="element-233" />
    </div>;
};